import React from 'react';

const BecomeMember = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Become a Forum Member</h1>
        <p>Join our network of business leaders</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="contact-form-wrapper">
            <h2>Membership Application</h2>
            <form className="contact-form">
              <div className="form-group">
                <label>Full Name</label>
                <input type="text" placeholder="Your full name" />
              </div>
              <div className="form-group">
                <label>Company/Organization</label>
                <input type="text" placeholder="Company name" />
              </div>
              <div className="form-group">
                <label>Email Address</label>
                <input type="email" placeholder="your@email.com" />
              </div>
              <div className="form-group">
                <label>Phone Number</label>
                <input type="tel" placeholder="Your phone number" />
              </div>
              <div className="form-group">
                <label>Industry/Sector</label>
                <input type="text" placeholder="Your industry" />
              </div>
              <div className="form-group">
                <label>Why do you want to join?</label>
                <textarea rows="4" placeholder="Tell us about yourself..."></textarea>
              </div>
              <button type="submit" className="btn-gold">Submit Application</button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BecomeMember;